import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectSelectedIncompleteFertilizerEventsUuids } from '../FertilizerEventsVirtualizedTable/selectors';

const selectHasIncompleteFertilizerEvents = createDeepEqualSelector(
    selectSelectedIncompleteFertilizerEventsUuids,
    (incompleteFertilizerEvents) =>
        !!(incompleteFertilizerEvents && incompleteFertilizerEvents.length)
);

export { selectHasIncompleteFertilizerEvents };
